import React from 'react';

import { di } from 'react-magnetic-di';

import { FormRenderMode } from '../../../../../../../common/types/render-mode';
import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { useFormRenderMode } from '../../../../../../../controllers/form-renderer-store';
import { EditSingleSelectInput } from './edit';
import { PreviewSingleSelectInput } from './preview';
import { ViewSingleSelectInput } from './view';

export const SingleSelectInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
	fieldErrorId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormRenderMode);
	const renderMode = useFormRenderMode();

	if (renderMode === FormRenderMode.EDIT) {
		return (
			<EditSingleSelectInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	if (renderMode === FormRenderMode.PREVIEW) {
		return (
			<PreviewSingleSelectInput
				fieldId={fieldId}
				fieldInputId={fieldInputId}
				fieldLabelId={fieldLabelId}
				fieldErrorId={fieldErrorId}
			/>
		);
	}

	return (
		<ViewSingleSelectInput
			fieldId={fieldId}
			fieldInputId={fieldInputId}
			fieldLabelId={fieldLabelId}
			fieldErrorId={fieldErrorId}
		/>
	);
};
